export default "__VITE_ASSET__Cy1hpktW__"